'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Component = require('./Component');

var _Component2 = _interopRequireDefault(_Component);

var _components = {
	_$CKEditor: {
		displayName: 'CKEditor'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var CKEditor = (function (_Component) {
	_inherits(CKEditor, _Component);

	function CKEditor(props) {
		_classCallCheck(this, _CKEditor);

		_Component.call(this, props);
		this.data = props.value;
	}

	CKEditor.prototype.componentDidMount = function componentDidMount() {
		var _this = this;

		var config = {
			"height": "400",
			"width": "800",
			"plugins": "basicstyles,button,clipboard,enterkey,indent,link,list,sourcearea,toolbar,undo,wysiwygarea",
			'extraPlugins': 'htmlwriter',
			"toolbar": [["Source", "-", "Bold", "Italic", "-", "NumberedList", "BulletedList", "-", "Link", "Unlink"]]
		};
		if (!this.ckeditor) {
			this.ckeditor = CKEDITOR.replace(_reactDom2['default'].findDOMNode(this), config);
			this.ckeditor.on('change', function () {
				_this.data = _this.ckeditor.getData();
				_this.handleChange();
			});
			this.ckeditor.on('instanceReady', function () {
				_this.updateEditor();
			});
		}
	};

	CKEditor.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		if (this.props.value != nextProps.value && this.data != nextProps.value) {
			this.data = nextProps.value;
			this.updateEditor();
		}
	};

	CKEditor.prototype.componentWillUnmount = function componentWillUnmount() {
		this.destroyCkeditor();
	};

	CKEditor.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
		return false;
	};

	CKEditor.prototype.updateEditor = function updateEditor() {
		this.ckeditor.setData(this.data, { noSnapshot: true });
	};

	CKEditor.prototype.destroyCkeditor = function destroyCkeditor() {
		if (this.ckeditor) {
			this.data = this.ckeditor.getData();
			this.ckeditor.destroy();
			this.ckeditor = null;
		}
	};

	CKEditor.prototype.handleChange = function handleChange() {
		if (this.props.onChange) {
			this.props.onChange(this.data);
		}
		if (this.props.onBlur) {
			this.props.onBlur(this.data);
		}
	};

	CKEditor.prototype.render = function render() {
		return _react2['default'].createElement('textarea', null);
	};

	var _CKEditor = CKEditor;
	CKEditor = _wrapComponent('_$CKEditor')(CKEditor) || CKEditor;
	return CKEditor;
})(_Component2['default']);

exports['default'] = CKEditor;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/reactis/reactis-inputs/CKEditor.js
 ** module id = 1008
 ** module chunks = 1
 **/